import {
  Breadcrumb,
  Button,
  PageHeader,
  Table,
  message,
  Tag,
  Modal,
} from "antd";

import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Page from "_components/Page";
import { extraService, stockReceiptService, taxTypeService } from "_services";
import "../style.css";
import { CurrencyFormatter } from "_helpers/formatters";
import Search from "./Search";

const TiepList = () => {
  const { path } = matchMedia;
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);
  const [taxTypes, setTaxtypes] = useState([]);
  const [searchParams, setSearchParams] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    getTaxTypes();
    getPurchaseOrders(pageNumber, pageSize);
  }, []);

  useEffect(() => {
    getPurchaseOrders(pageNumber, pageSize);
  }, [searchParams]);

  const getTaxTypes = () => {
    taxTypeService
      .getAll()
      .then((data) => setTaxtypes(data.content))
      .catch((error) => message.error(error));
  };

  const getPurchaseOrders = (pageNumber, pageSize) => {
    let paginationParams = searchParams.indexOf("?") === -1 ? "?" : "&";
    paginationParams += `pageNumber=${pageNumber}&pageSize=${pageSize}`;

    setLoading(true);
    stockReceiptService
      .search(`${searchParams}${paginationParams}`)
      .then((data) => {
        setItems(data.content);
        setLoading(false);
        setTotalRecords(data.pagination.totalRecords);
        setPageNumber(pageNumber);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  };

  const handleSearchResults = (searchParams) => {
    setSearchParams(searchParams);
  };

  const getActionButtons = () => {
    let buttons = [];

    return buttons;
  };
  const getColumns = () => [
    {
      title: "Customs Ref.Number",
      key: "customRefNumber",
      width: "5%",
      dataIndex: "customRefNumber",
      render: (text, record) => (
        <Link to={`/stock-delete/${record.id}/summary`}>{text}</Link>
      ),
    },

    {
      title: "Receipt Number",
      dataIndex: "receiptNumber",
      width: "5%",
      key: "receiptNumber",
    },

    {
      title: "Receipt Type",
      key: "receiptType",
      width: "10%",
      dataIndex: "receiptType",
      render: (text, record) => (text == "LOCAL" ? "INDIRECT" : "DIRECT"),
    },
    {
      title: "Receipt Date",
      dataIndex: "receivedDate",
      width: "8%",
      key: "receivedDate",
      render: (text, record) => moment(text).format("YYYY-MM-DD"),
    },
    {
      title: "VAT",
      dataIndex: "totalVatAmount",
      align: "right",
      key: "totalVatAmount",
      render: (text, record) => CurrencyFormatter(text ?? 0),
    },
    {
      title: "Liability",
      dataIndex: "totalLiabilityAmount",
      align: "right",
      key: "totalLiabilityAmount",
      render: (text, record) => <b>{CurrencyFormatter(text ?? 0)}</b>,
    },

    ...(taxTypes ?? []).map((item) => ({
      title: `${item.name}`,
      dataIndex: ["stockReceiptTaxViews"],
      align: "right",
      key: `${item.code}`,
      render: (text, record) => {
        const taxEntry = record.stockReceiptTaxViews?.find(
          (tax) => tax.code === item.code
        );
        return <b>{CurrencyFormatter(taxEntry?.totalTaxAmount ?? 0)}</b>;
      },
    })),
    {
      title: "Status",
      dataIndex: "orderStage",
      key: "orderStage",
      width: "5%",
      render: (orderStatus) => {
        let color = "";
        if (orderStatus === "COMPLETE") {
          color = "#87d068";
        }
        if (orderStatus === "OPEN") {
          color = "#2db7f5";
        }
        if (orderStatus === "IN_PROGRESS") {
          color = "#108ee9";
        }
        return <Tag color={color}>{orderStatus}</Tag>;
      },
    },
  ];

  const handlePaginateChange = (pageNumber, pageSize) => {
    getPurchaseOrders(pageNumber, pageSize);
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/stock-receipts">Search Imports</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Search onSearch={handleSearchResults} />
          <Table
            bordered
            loading={loading}
            rowKey="id"
            size="small"
            scroll={{ x: 1800 }}
            columns={getColumns()}
            dataSource={items}
            pagination={{
              current: pageNumber,
              pageSize: pageSize,
              total: totalRecords,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: false,
              onChange: handlePaginateChange,
            }}
          />
        </Page>
      </PageHeader>
    </div>
  );
};

export { TiepList };
